import { Auto_generateBoxedDecoder_Z6670B51, fromString } from "../fable_modules/Thoth.Json.10.0.0/./Decode.fs.js";
import { uncurry2 } from "../fable_modules/fable-library.4.1.4/Util.js";
import { class_type, string_type } from "../fable_modules/fable-library.4.1.4/Reflection.js";
import { Defaults_database, Core_Creature_$reflection } from "../Domain/Domain.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../fable_modules/Thoth.Json.10.0.0/./Encode.fs.js";

export function Cache_create() {
    let cache = void 0;
    return [(onCacheMiss) => ((arg) => ((cache == null) ? onCacheMiss(arg) : cache)), () => {
        cache = void 0;
    }];
}

export const Catalog_key = "Catalog";

export const Catalog_patternInput$004035 = Cache_create();

export const Catalog_cacheRead = Catalog_patternInput$004035[0];

export const Catalog_cacheInvalidate = Catalog_patternInput$004035[1];

export function Catalog_read() {
    return Catalog_cacheRead((fallback) => {
        const fallback_1 = fallback;
        try {
            const str = window.localStorage[Catalog_key];
            const matchValue = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Core_Creature_$reflection()]), void 0, void 0)), str);
            return (matchValue.tag === 1) ? fallback_1() : matchValue.fields[0];
        }
        catch (matchValue_1) {
            return fallback_1();
        }
    })(Defaults_database);
}

export function Catalog_write(v) {
    window.localStorage[Catalog_key]=toString(0, Auto_generateBoxedEncoder_437914C6(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Core_Creature_$reflection()]), void 0, void 0, void 0)(v));
    Catalog_cacheInvalidate();
}

//# sourceMappingURL=LocalStorage.fs.js.map
